module.exports = __webpack_public_path__ + "media/call.3ea640d6.mp3";